import { useState } from "react";
import { Mail, Check } from "lucide-react";
import { subscribeNewsletter } from "../../lib/api";

export const NewsletterSignup = ({ slug, lieu, sessionId }) => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      const r = await subscribeNewsletter({ email, slug, lieu: lieu || null, session_id: sessionId });
      setStatus(r.already ? "already" : "done");
    } catch {
      setStatus("error");
    }
  };

  if (status === "done" || status === "already")
    return (
      <section data-testid="newsletter-success" className="mt-6 border border-[#2C402E] p-6 text-center">
        <p className="font-serif italic text-lg text-[#2C402E]">
          <Check size={18} className="inline -mt-1 mr-2" />{status === "done" ? "Merci ! Vous êtes inscrit(e) à notre newsletter." : "Vous êtes déjà inscrit(e), merci !"}
        </p>
      </section>
    );

  return (
    <section data-testid="newsletter-signup" className="mt-6 border border-[#D1CFC7] p-6">
      <p className="flex items-center gap-2 text-[10px] tracking-[0.3em] uppercase text-[#9E4735] font-body mb-2"><Mail size={12} /> Newsletter culturelle</p>
      <p className="font-serif text-xl text-[#1A1A1A] mb-4">Recevez nos nouvelles histoires, parutions et rencontres d'auteurs.</p>
      <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="votre@email.com" data-testid="newsletter-email-input" className="flex-1 min-w-0 bg-[#FAF9F6] border border-[#D1CFC7] focus:border-[#2C402E] px-4 py-3 outline-none font-body text-sm" />
        <button type="submit" disabled={status === "loading"} data-testid="newsletter-submit-button" className="bg-[#1A1A1A] hover:bg-[#2C402E] text-[#FAF9F6] px-6 py-3 font-body text-sm transition-colors disabled:opacity-50">
          {status === "loading" ? "…" : "Je m'abonne"}
        </button>
      </form>
      {status === "error" && <p data-testid="newsletter-error" className="text-xs font-body text-[#9E4735] mt-2">Adresse e-mail invalide, veuillez réessayer.</p>}
      <p className="text-[11px] font-body text-[#757575] mt-3">Désinscription possible à tout moment. Votre adresse n'est jamais partagée.</p>
    </section>
  );
};
